fx.ns("shared.popups", class MessagePopup extends fx.components.Popup{
    
    constructor(message, width, height)
    {
        super();
        this.contentWidth = width || 300;
        this.contentHeight = height || 200;

        this._message = message;

        this.showClose = true;
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.cancelButton);
    }


    create()
    {
        super.create();

        this.addChild(new fx.components.Text({text:this._message, className:"text"}), {height:"100%", left:0, top:30, width:"100%"});

        this.cancelButton = new fx.components.Button({label : fx.text("Ok")});
        this.addChild(this.cancelButton, {bottom:20, height:60, width : 200, left:"center"});
    }


});